// extracted by mini-css-extract-plugin
module.exports = {"blurb":"SeoBlurb--blurb","textContainer":"SeoBlurb--textContainer","collapsed":"SeoBlurb--collapsed","fadeBox":"SeoBlurb--fadeBox","expandContainer":"SeoBlurb--expandContainer"};